const titles = {
  analytics: "Reporting dashboard",
  banner: "Professional Banner",
  basicTags: "Basic tags",
  callButton: "Call Button",
  calAvailability: "Calendar Availability",
  calIntegration: "Calendar integration",
  clientEmailAddress: "Client email address",
  clientInvoice: "Client invoicing",
  clientPhoneNumber: "Client phone number",
  compAnalytics: "Industry insights",
  contactDetails: "Contact details",
  corpConcierge: "Concierge enquiries",
  externalMarketing: "Discounted external marketing",
  flexiblePrices: "Flexible prices",
  homepage: "Feature on Homepages",
  manager48h: "On-hand account management team 48hr reply",
  noCommission: "Pay no commission",
  onlinePayment: "Online payment",
  partnerDiscount: "Partner Discounts",
  personalManager: "Own account manager",
  premiumTags: "Premium event types",
  quarterlyOffers: "Quarterly feature on offers page",
  quarterlyReview: "Quarterly profile review",
  spaceListing: "Space listing",
  teamAccess: "Team management",
  top3pages: "Listing boost to page 1-3 in search",
  topPage: "Listing boost to page 1 in search",
  unlimitedEnquiries: "Unlimited enquiries",
};

// rearrange for display order
const display = [
  titles.unlimitedEnquiries,
  titles.clientPhoneNumber,
  titles.clientEmailAddress,
  titles.noCommission,
  titles.top3pages,
  titles.topPage,
  titles.premiumTags,
  titles.corpConcierge,
  titles.personalManager,
  titles.onlinePayment,
  titles.clientInvoice,
  titles.teamAccess,
  titles.flexiblePrices,
  titles.analytics,
  // titles.contactDetails,
  // titles.compAnalytics,
  // titles.quarterlyReview,
];

// explanations to show in tooltips for titles (if needed)
// add one here and it will automatically appear in the subscription comparison table as a tooltip
const explanations = {
  [titles.clientPhoneNumber]: `Access to the organiser's direct phone number`,
  [titles.clientEmailAddress]: `Access to the organiser's direct email address`,
  [titles.noCommission]: `No commission charged on marketplace enquiries that book your venue`,
  [titles.top3pages]: `Venue guaranteed to appear in the top 3 pages of search results for relevant searches`,
  [titles.topPage]: `Venue guaranteed to appear on the first page of search results for relevant searches`,
  [titles.premiumTags]: `We offer four premium event types: weddings, christmas parties, conferences and team away days. The number of these event types you can choose to receive varies by subscription plan`,
  [titles.corpConcierge]: `Receive high value corporate enquiries handled by our concierge team. We do charge venues a small commission on any Concierge enquiries that turn into bookings`,
  [titles.personalManager]: `One of our team will be dedicated to your account, and will arrange regular calls or meetings to review your performance and help you get the most from VenueScanner`,
  [titles.onlinePayment]: `Access to an optional online payment system, via our integration with Stripe, which lets you give organisers the ability to pay for their booking online`,
  [titles.flexiblePrices]: `Vary your pricing by day of the week or for specific periods of time`,
};

const comparison = {};
display.forEach((title) => {
  comparison[title] = {
    icon: "cross",
    text: null,
  };
});
const baseOn = [
  titles.unlimitedEnquiries,
  titles.callButton,
  titles.onlinePayment,
  titles.clientInvoice,
  titles.flexiblePrices,
  titles.analytics,
  titles.calAvailability,
  titles.manager48h,
  titles.contactDetails,
  titles.noCommission,
];
baseOn.forEach((title) => {
  comparison[title] = {
    icon: "tick",
  };
});
comparison[titles.calIntegration] = {
  icon: "astericks",
};

module.exports = {
  titles,
  display,
  explanations,
  UNLIMITED: {
    tag: "unlimited",
    description: "",
    tag_line:
      "Unlimited enquiries, access to organisers’ phone numbers and email addresses and no commission to pay on bookings.",
    pros: [
      `Unlimited commission free enquiries`,
      `Organisers' direct contact details`,
    ],
    comparison: {
      ...comparison,
      [titles.unlimitedEnquiries]: {
        icon: "tick",
      },
      [titles.clientPhoneNumber]: {
        icon: "tick",
      },
      [titles.clientEmailAddress]: {
        icon: "tick",
      },
      [titles.noCommission]: {
        icon: "tick",
      },
      [titles.premiumTags]: {
        icon: null,
        text: "0",
      },
      [titles.onlinePayment]: {
        icon: "tick",
      },
      [titles.clientInvoice]: {
        icon: "tick",
      },
      [titles.teamAccess]: {
        icon: "tick",
      },

      [titles.flexiblePrices]: {
        icon: "tick",
      },
      [titles.analytics]: {
        icon: "tick",
      },
      [titles.basicTags]: {
        icon: null,
        text: "5",
      },
      [titles.spaceListing]: {
        icon: null,
        text: "5",
      },
    },
  },
  PRO: {
    tag: "pro",
    description: "<span>All Starter</span> +",
    tag_line:
      "All of the benefits of Starter, access to two premium event types (such as Christmas parties & weddings) and a boost in search rankings.",
    pros: [
      `Unlimited commission free enquiries`,
      `Organisers’ direct contact details`,
      `Two premium event types`,
      `Access to corporate Concierge`,
      `Increased prominence in search results`,
    ],
    comparison: {
      ...comparison,
      [titles.unlimitedEnquiries]: {
        icon: "tick",
      },
      [titles.clientPhoneNumber]: {
        icon: "tick",
      },
      [titles.clientEmailAddress]: {
        icon: "tick",
      },
      [titles.noCommission]: {
        icon: "tick",
      },
      [titles.top3pages]: {
        icon: "tick",
      },
      [titles.premiumTags]: {
        icon: null,
        text: "2",
      },
      [titles.corpConcierge]: {
        icon: "tick",
      },
      [titles.onlinePayment]: {
        icon: "tick",
      },
      [titles.clientInvoice]: {
        icon: "tick",
      },
      [titles.teamAccess]: {
        icon: "tick",
      },
      [titles.flexiblePrices]: {
        icon: "tick",
      },
      [titles.analytics]: {
        icon: "tick",
      },

      [titles.basicTags]: {
        icon: "tick",
      },
      [titles.compAnalytics]: {
        icon: "tick",
      },
      [titles.contactDetails]: {
        icon: "tick",
      },
      [titles.quarterlyOffers]: {
        icon: "tick",
      },
      [titles.spaceListing]: {
        icon: null,
        text: "up to 5",
      },
    },
    variants: {
      min: {
        description:
          "Unlimited enquiries and booking, calendar management, data analytics software & an enhanced profile attracting more eyeballs and enquiries",
        pros: [
          null,
          null,
          null,
          "Enquiry management: instant messaging, reply by email, call button, calendar management software, API, multiple users & notification email addresses",
        ],
      },
    },
  },
  GOLD: {
    tag: "gold",
    description: "<span>All Professional</span> +",
    tag_line:
      "All of the benefits of Professional, access to all premium event types and Concierge enquiries, guaranteed page 1 position in search results.",
    pros: [
      `Unlimited commission free enquiries`,
      `Organisers' direct contact details`,
      `All premium event types`,
      `Access to corporate Concierge`,
      `Appear on page 1 of search results`,
    ],
    comparison: {
      ...comparison,
      [titles.unlimitedEnquiries]: {
        icon: "tick",
      },
      [titles.clientPhoneNumber]: {
        icon: "tick",
      },
      [titles.clientEmailAddress]: {
        icon: "tick",
      },
      [titles.noCommission]: {
        icon: "tick",
      },
      [titles.topPage]: {
        icon: "tick",
      },
      [titles.premiumTags]: {
        icon: null,
        text: "4",
      },
      [titles.corpConcierge]: {
        icon: "tick",
      },
      [titles.personalManager]: {
        icon: "tick",
      },
      [titles.onlinePayment]: {
        icon: "tick",
      },
      [titles.clientInvoice]: {
        icon: "tick",
      },
      [titles.teamAccess]: {
        icon: "tick",
      },
      [titles.flexiblePrices]: {
        icon: "tick",
      },
      [titles.analytics]: {
        icon: "tick",
      },

      [titles.banner]: {
        icon: "tick",
        text: "*earn",
      },
      [titles.basicTags]: {
        icon: "tick",
      },
      [titles.compAnalytics]: {
        icon: "tick",
      },
      [titles.contactDetails]: {
        icon: "tick",
      },
      [titles.externalMarketing]: {
        icon: "tick",
      },
      [titles.homepage]: {
        icon: "tick",
      },
      [titles.partnerDiscount]: {
        icon: "tick",
      },

      [titles.quarterlyOffers]: {
        icon: "tick",
      },
      [titles.quarterlyReview]: {
        icon: "tick",
      },
      [titles.spaceListing]: {
        icon: null,
        text: "up to 10",
      },
    },
    variants: {
      min: {
        description:
          'Unlimited enquiries and booking, calendar management, data analytics software, an enhanced profile attracting more eyeballs and enquiries + extended digital marketing reach, delivering unbeatable ROI",',
        pros: [
          null,
          null,
          null,
          "Enquiry management: instant messaging, reply by email, call button, calendar management software, API, multiple users, notification email addresses & priority access to VIP Concierge* clients&lsquo; high value enquiries",
        ],
      },
    },
  },
};
